
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/jobstars-india",
      function () {
        return require("private-next-pages/case-study/jobstars-india.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/jobstars-india"])
      });
    }
  